import { render, staticRenderFns } from "./premiumList.vue?vue&type=template&id=df386f50&scoped=true"
import script from "./premiumList.vue?vue&type=script&lang=js"
export * from "./premiumList.vue?vue&type=script&lang=js"
import style0 from "./premiumList.vue?vue&type=style&index=0&id=df386f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df386f50",
  null
  
)

export default component.exports